<template>
  <Teleport to="body">
    <Transition name="quota-modal-fade">
      <div v-if="quotaModalVisible.value" class="quota-modal-overlay" @click.self="closeQuotaModal">
        <div class="quota-modal-card" @click.stop>
          <div class="quota-modal-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19.82 2H4.18C2.97602 2 2 2.97602 2 4.18V19.82C2 21.024 2.97602 22 4.18 22H19.82C21.024 22 22 21.024 22 19.82V4.18C22 2.97602 21.024 2 19.82 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M7 2V22" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M17 2V22" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M2 12H22" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M2 7H7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M2 17H7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M17 17H22" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M17 7H22" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <h3 class="quota-modal-title">体验次数已用完</h3>
          <p class="quota-modal-message">
            感谢您的试用与支持！<br>
            当前为内测体验阶段，生成次数已全部使用。<br>
            更多功能敬请期待正式版本发布。
          </p>
          <div class="quota-modal-actions">
            <button class="quota-modal-btn quota-modal-btn--primary" @click="closeQuotaModal">我知道了</button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { useModal } from '../composables/useModal'

const { quotaModalVisible, closeQuotaModal } = useModal()
</script>

<style scoped>
.quota-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(4px);
}

.quota-modal-card {
  background: #fff;
  border-radius: 16px;
  padding: 32px 36px;
  min-width: 380px;
  max-width: 440px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  text-align: center;
  animation: quota-modal-scale-in 0.2s ease-out;
}

.quota-modal-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: linear-gradient(135deg, #eff6ff, #dbeafe);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  font-size: 24px;
  color: #2563eb;
}

.quota-modal-title {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 12px;
}

.quota-modal-message {
  font-size: 14px;
  color: #6b7280;
  line-height: 1.75;
  margin-bottom: 28px;
}

.quota-modal-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
}

.quota-modal-btn {
  padding: 10px 24px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all 0.15s;
  font-family: inherit;
}

.quota-modal-btn--primary {
  background: #2563eb;
  color: white;
}
.quota-modal-btn--primary:hover {
  background: #1d4ed8;
}

.quota-modal-fade-enter-active,
.quota-modal-fade-leave-active {
  transition: opacity 0.2s ease;
}
.quota-modal-fade-enter-from,
.quota-modal-fade-leave-to {
  opacity: 0;
}

@keyframes quota-modal-scale-in {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}
</style>
